import React from 'react'
import TableFixedPage from '../../TableFixedPage/TableFixedPage'
import IntelegentVoiceOrderTable from '../../Tables/OrderPart/IntelegentVoiceOrderTable/IntelegentVoiceOrderTable'

const IntelegentVoiceOrderContainer = () => {
  return (
    <>
    <TableFixedPage title={" سفارشات هوشمند صوتی "} />
    <IntelegentVoiceOrderTable data={[]}/>
    </>
  )
}

export default IntelegentVoiceOrderContainer